import React from 'react';
import moment from 'moment';
import { isNull } from 'lodash/fp';
import FormattedDate from 'components/shared/FormattedDate';
import Table from 'components/shared/table';
import TemplateStatus from 'components/editor/HeaderV2/TemplateStatus';

const TemplateRow = ({
  id,
  activeTemplate,
  title,
  lastUpdatedAt,
  createdAt,
  lessonsCreated,
}) => {
  const modifiedField = lastUpdatedAt || createdAt;
  const dayAgo = moment().subtract(1, 'day');

  return (
    <Table.Row>
      <Table.BodyCell split size="xl">
        <span className="text-wrap">
          <a href={`/templates/${id}/edit`}>{title}</a>
        </span>
      </Table.BodyCell>
      <Table.BodyCell size="m">
        <span>
          <TemplateStatus templateActive={activeTemplate} />
        </span>
      </Table.BodyCell>
      <Table.BodyCell size="l">
        <span className="ta-c">
          {isNull(lessonsCreated) ? '-' : lessonsCreated}
        </span>
      </Table.BodyCell>
      <Table.BodyCell size="s">
        <span>
          {moment(modifiedField.date) <= dayAgo ? (
            <FormattedDate>{modifiedField.date}</FormattedDate>
          ) : (
            moment(modifiedField.date).fromNow()
          )}
        </span>
        <div className="c-midnight-70">
          {lastUpdatedAt ? t('common.updated_by') : t('common.created_by')}{' '}
          {modifiedField.user.name}
        </div>
      </Table.BodyCell>
    </Table.Row>
  );
};

export default TemplateRow;
